import React from "react";
import {
  Typography,
  Box,
  Grid,
  Card,
  CardMedia,
  Button,
  Stack,
  Container,
} from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import CallIcon from "@mui/icons-material/Call";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import NorthWestIcon from "@mui/icons-material/NorthWest";
// import { useNavigate } from "react-router-dom";

import AboutImg1 from "../images/Untitled2.png";
import AboutImg2 from "../images/Untitled1.png";
import AboutImg3 from "../images/image.png";

/* =======================
   IMAGE DATA
======================= */
const imageData = [
  {
    id: 1,
    image: AboutImg1,
    height: 290,
    name: "Quazi Farhad Ahmed",
    title: "Chief Executive Officer",
  },
  {
    id: 2,
    image: AboutImg3,
    height: 200,
    name: "",
    title: "",
  },
  {
    id: 3,
    image: AboutImg2,
    height: 320,
    name: "Zahir Ahmed",
    title: "Chief Commercial Officer",
    border: true,
  },
];

/* =======================
   REUSABLE IMAGE CARD
======================= */
const HoverImage = ({ image, height, name, title, border }) => (
  <Card
    sx={{
      position: "relative",
      boxShadow: 3,
      overflow: "hidden",
      border: border ? "24px solid white" : "none",
    }}
  >
    <Box
      sx={{
        position: "relative",
        cursor: "pointer",
        "&:hover img": {
          filter: "brightness(70%)",
          transform: "scale(1.05)",
        },
      }}
    >
      <CardMedia
        component="img"
        image={image}
        height={height}
        sx={{
          transition: "all 0.4s ease",
        }}
      />

      {/* 🔽 ALWAYS VISIBLE TEXT INSIDE IMAGE */}
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          width: "100%",
          background:
            "linear-gradient(to top, rgba(0,0,0,0.7), rgba(0,0,0,0))",
          color: "#fff",
          px: 2,
          py: 1.5,
          textAlign: "left",
        }}
      >
        <Typography fontWeight="bold" fontSize={16}>
          {name}
        </Typography>
        <Typography fontSize={13}>{title}</Typography>
      </Box>
    </Box>
  </Card>
);

/* =======================
   ABOUT COMPONENT
======================= */
function About() {
  // const navigate = useNavigate();

  return (
    <Box
      sx={{
        backgroundColor: "#f9f9f9",
        py: 6,
        px: 2,
        width: "100vw",
        maxWidth: "1900px",
        mt: 2,
      }}
    >
      <Container id="about-section">
        <Grid container spacing={4} alignItems="center">
          {/* LEFT SIDE */}
          <Grid item xs={12} md={7}>
            <Stack spacing={2}>
              {/* MAIN IMAGE */}
              <Box sx={{ width: { xs: 300, md: 450 } }}>
                <HoverImage {...imageData[0]} />
              </Box>

              {/* BOTTOM IMAGES */}
              <Grid container spacing={2}>
                <Grid item xs={6} sx={{ ml: -2, mr: 2 }}>
                  <HoverImage {...imageData[1]} />
                </Grid>

                <Grid item xs={6} sx={{ mt: -16 }}>
                  <HoverImage {...imageData[2]} />
                </Grid>
              </Grid>
            </Stack>
          </Grid>

          {/* RIGHT SIDE */}
          <Grid item xs={12} md={5}>
            <Stack spacing={3}>
              <Box>
                <NorthWestIcon sx={{ color: "#0F758E", mr: 1 }} />
                <Typography
                  variant="overline"
                  sx={{ fontWeight: "bold", fontSize: 20, color: "#0F758E" }}
                >
                  Our Track Record
                </Typography>

                <Typography variant="h4" fontWeight="bold" gutterBottom>
                  Global Procurement Excellence
                </Typography>

                <Typography color="text.secondary">
                  To provide reliable, compliant, and efficient procurement
                  solutions for defence contracts, equipment supply, and global
                  product sourcing while maintaining the highest standards.
                </Typography>
              </Box>

              {/* BULLETS */}
              <Box>
                {[
                  "Government Contracts: 5+ in pipeline",
                  "On-Time Delivery: 98% target",
                  "Compliance Rate: 100%",
                  "Strategic Partners: 3+ OEM partnerships",
                ].map((item, index) => (
                  <Typography
                    key={index}
                    sx={{ display: "flex", alignItems: "center", gap: 1 }}
                  >
                    <CheckBoxIcon sx={{ color: "#0F758E" }} />
                    {item}
                  </Typography>
                ))}
              </Box>

              {/* BUTTON & CALL */}
              <Grid container>
                <Grid item xs={6}>
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "#0F758E",
                      fontWeight: "bold",
                      fontSize: 18,
                      textTransform: "none",
                      "&:hover": {
                        backgroundColor: "white",
                        color: "#0F758E",
                        border: "2px solid #0F758E",
                      },
                    }}
                  // onClick={() => navigate("/about")}
                  >
                    Call Any Time <PlayArrowIcon sx={{ ml: 1 }} />
                  </Button>
                </Grid>

                <Grid item xs={6}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      color: "#0F758E",
                      mt: 1
                    }}
                  >
                    <CallIcon />
                    <Box ml={2}>
                      {/* <Typography fontWeight="bold">
                        Call Any Time
                      </Typography> */}
                      <Typography>+1 647 545 7225</Typography>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default About;
